/**
 * @deprecated use window.fetch instead. i.e., fetch(url,{ credentials: "include", headers: { "Content-Type": "application/json", method: "GET" }
 * @param {string} url - api request url (including any query strings)
 * @param {object} additionalConfig - any additional configurations for requests
 * @returns { data, error } object with data from API in data key, and any error in error key
 */
const getAsyncRequest = async (url = "", additionalConfig = {}) => {
  try {
    const urlObj = new URL(`${window.gxApiConnection}${url.startsWith("/") ? url : `/${url}`}`);
    if (additionalConfig.params) {
      Object.entries(additionalConfig.params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          urlObj.searchParams.append(key, String(value));
        }
      });
    }
    const fetchResponse = await window.fetch(urlObj.toString(), {
      method: "GET",
      credentials: "include",
    });
    return {
      status: fetchResponse.status,
      statusText: fetchResponse.statusText,
      data: await fetchResponse.json()
    };
  } catch (error) {
    return { status: 500, statusText: "", data: {} };
  }
};

export default getAsyncRequest;
